import { render, staticRenderFns } from "./CommentButtons.vue?vue&type=template&id=3db4d305&lang=html&"
import script from "./CommentButtons.vue?vue&type=script&lang=js&"
export * from "./CommentButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports